"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGetPaymentReceiptDto = instanceOfGetPaymentReceiptDto;
exports.GetPaymentReceiptDtoFromJSON = GetPaymentReceiptDtoFromJSON;
exports.GetPaymentReceiptDtoFromJSONTyped = GetPaymentReceiptDtoFromJSONTyped;
exports.GetPaymentReceiptDtoToJSON = GetPaymentReceiptDtoToJSON;
exports.GetPaymentReceiptDtoToJSONTyped = GetPaymentReceiptDtoToJSONTyped;
/**
 * Check if a given object implements the GetPaymentReceiptDto interface.
 */
function instanceOfGetPaymentReceiptDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('depositAmount' in value) || value['depositAmount'] === undefined)
        return false;
    if (!('totalPaid' in value) || value['totalPaid'] === undefined)
        return false;
    return true;
}
function GetPaymentReceiptDtoFromJSON(json) {
    return GetPaymentReceiptDtoFromJSONTyped(json, false);
}
function GetPaymentReceiptDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'depositAmount': json['depositAmount'],
        'totalPaid': json['totalPaid'],
    };
}
function GetPaymentReceiptDtoToJSON(json) {
    return GetPaymentReceiptDtoToJSONTyped(json, false);
}
function GetPaymentReceiptDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'depositAmount': value['depositAmount'],
        'totalPaid': value['totalPaid'],
    };
}
